import React from 'react'
import './ShareModal.css'
import {
  EmailShareButton, EmailIcon,
  FacebookShareButton, FacebookIcon,
  TelegramShareButton, TelegramIcon,
  TwitterShareButton, TwitterIcon,
  WhatsappShareButton, WhatsappIcon,
  RedditShareButton , RedditIcon
} from 'react-share'


const ShareModal = ({url}) => {
  return (
    <div className="social2__share_modal">
      <FacebookShareButton url={url}>
        <FacebookIcon round={true} size={32}/>
      </FacebookShareButton>

      <EmailShareButton url={url}>
        <EmailIcon round={true} size={32}/>
      </EmailShareButton>

      <TelegramShareButton url={url}>
        <TelegramIcon round={true} size={32}/>
      </TelegramShareButton>

      <TwitterShareButton url={url}>
        <TwitterIcon round={true} size={32}/>
      </TwitterShareButton>

      <WhatsappShareButton url={url}>
        <WhatsappIcon round={true} size={32}/>
      </WhatsappShareButton>

      <RedditShareButton url={url}>
        <RedditIcon round={true} size={32}/>
      </RedditShareButton>
    </div>
  )
}

export default ShareModal
